import React, { Component } from "react";
import "./Login.css";
import axios from "axios";
import "./Signin.css";
import Cookies from "js-cookie";

class Recovery extends Component {
  state = {
    email: "",
    validationError: null,
    sentEmail: false,
    loading: false,
  };

  begin_recovery = () => {
    this.setState({ loading: true });
    if (this.state.email === "" || this.state.email === null) {
      this.setState({ validationError: "Enter an email address" });
      this.setState({ loading: false });
      return;
    }
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.state.email
      )
    ) {
      this.setState({ validationError: "Enter a valid email address" });
      this.setState({ loading: false });
      return;
    }

    this.setState({ validationError: null });

    axios
      .get(this.props.baseUrl + "/api/reset_password/")
      .then((response) => {
        const csrftoken = Cookies.get("csrftoken");
        if (csrftoken) {
          const formData = new FormData();
          formData.append("email", this.state.email);
          formData.append("csrfmiddlewaretoken", csrftoken);

          axios
            .post(this.props.baseUrl + "/api/reset_password/", formData, {
              withCredentials: true,
            })
            .then((response) => {
              this.setState({ loading: false });
              this.setState({ sentEmail: true });
            })
            .catch((errors) => {
              this.setState({
                validationError: (
                  <>
                    An error occurred, please try again.
                    <br />
                    <br />
                    If the error persists please contact{" "}
                    <a href="mailto:info@spatiam.com?subject=Spatiam DTN Manager - Issue" target="_blank" rel="noopener noreferrer">
                      info@spatiam.com
                    </a>
                  </>
                ),
              });
              this.setState({ loading: false });
            });
        }
        else{
          this.setState({
            validationError: (
              <>
                An error occurred, please try again.
                <br />
                <br />
                If the error persists please contact{" "}
                <a href="mailto:info@spatiam.com?subject=Spatiam DTN Manager - Issue" target="_blank" rel="noopener noreferrer">
                  info@spatiam.com
                </a>
              </>
            ),
          });
          this.setState({ loading: false });
        }
      })
      .catch((errors) => {
        this.setState({
          validationError: (
            <>
              An error occurred, please try again.
              <br />
              <br />
              If the error persists please contact{" "}
              <a href="mailto:info@spatiam.com?subject=Spatiam DTN Manager - Issue" target="_blank" rel="noopener noreferrer">
                info@spatiam.com
              </a>
            </>
          ),
        });
        this.setState({ loading: false });
      });
    return;
  };

  inputChanged = (event) => {
    this.setState({ email: event.target.value });
  };

  renderErrors = () => {
    if (this.props.getRegistered()) {
      return (
        <li style={{ color: "rgb(30, 255, 0)" }} key={"registration success"}>
          Registration Successful. Please Sign In
        </li>
      );
    }

    const validationErrors = this.state.validationErrors;

    const error_tags = ["username", "password", "non_field_errors"];
    let errors = [];

    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      const error_tag = error_tags[i];
      const error_msg = validationErrors[error_tag];
      var msg = "";
      if (error_msg) {
        if (error_tag === "username") {
          msg = "Enter username";
        } else if (error_tag === "password") {
          msg = "Enter password";
        } else {
          msg = "The info doesn't match our records.\t Please try again.";
        }
        errors.push(
          <li style={{ color: "red" }} key={error_tags[i]}>
            {msg}
          </li>
        );
      }
    }

    return errors;
  };

  render() {
    return (
      <div className="input_area">
        <div className="title_area">
          <h1>Account Recovery</h1>
        </div>
        {this.state.sentEmail ? (
          <>
            <label>
              An email will be sent shortly with instructions for resetting your
              password, if an account exists with the email you entered.
              <br />
              <br />
              If you experience any issues contact us at info@spatiam.com
            </label>
          </>
        ) : (
          <>
            <label>
              Enter your account's email address to receive your username
              information and reset your password.
            </label>
            <label>
              Email address:
              <br />
              <input
                type="text"
                name="email"
                value={this.state.email}
                onChange={this.inputChanged}
              />
            </label>
            <></>
            <button
              className="login_button"
              disabled={this.state.loading}
              onClick={() => {
                this.begin_recovery();
              }}
            >
              {this.state.loading ? "Processing..." : "Send Recovery Email"}
            </button>
            <p style={{ color: "red", marginTop: "10px" }}>
              {this.state.validationError}
            </p>
          </>
        )}
      </div>
    );
  }
}

export default Recovery;